import { render, staticRenderFns } from "./_Account.vue?vue&type=template&id=0ad54993&scoped=true&"
import script from "./_Account.vue?vue&type=script&lang=js&"
export * from "./_Account.vue?vue&type=script&lang=js&"
import style0 from "./_Account.vue?vue&type=style&index=0&id=0ad54993&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad54993",
  null
  
)

export default component.exports